<lib-tooltip-menu #feedMenu>
	@if (feeds(); as feeds) {
	<div>
		<div libPad [style.min-width]="isMobileView() ? '350px' : '500px'">
			@if (feeds?.length) {
			<div>
				@for (feed of feeds; track feed.id; let first = $first) { @if (!first) {
				<lib-divider class="push-top push-bottom"></lib-divider>
				}
				<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'start'">
					<div libFlexColumn>
						<lib-image
							[alt]="feed.avatarName"
							[avatarName]="feed.avatarName"
							[image]="feed.feedImage"
							[imageSize]="'50px'"
							[maxWidth]="isMobileView() ? 35 : 40"
							[maxHeight]="isMobileView() ? 35 : 40"
						></lib-image>
					</div>
					<div libFlexColumn libFlexFill>
						<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'8px'">
							<div libFlexColumn libFlexFill libText2>
								{{ feed.title }}
							</div>
							<div libFlexColumn libText5>
								{{ feed.fromNow }}
							</div>
						</div>
						<div libText3>
							<lib-shorten-text [text]="feed.text" [disableShowMoreOrLessButton]="true">
							</lib-shorten-text>
						</div>
					</div>
				</div>
				}

				<div class="w-text-center">
					<lib-divider class="push-top push-bottom"></lib-divider>
					<lib-link [routerLink]="notificationsRouterLink" [linkStyle]="'default'"
						>All notifications</lib-link
					>
				</div>
			</div>
			} @else {
			<lib-message [type]="'info'">You have no notifications</lib-message>
			}
		</div>
	</div>
	}
</lib-tooltip-menu>

<!-- Primary menu -->
<ng-template #primaryMenuDesktopTemplate>
	@if (layoutType(); as layoutType) {
	<div class="w-box-wrapper">
		<div class="w-box-desktop">
			<div [id]="boxDesktopA" class="w-box-desktop-a">
				<div class="w-box-content">
					@if (brandLogoImage(); as brandLogoImage) {
					<div libFlexRow [libFlexRowAlign]="'center'" class="push" [libFlexRowGap]="'5px'">
						<div libFlexColumn [libFlexSize]="'50px'">
							<lib-link [displayStyle]="'block'" [routerLink]="dashboardUrl()">
								<lib-image
									[alt]="'Brand logo'"
									[priority]="true"
									[imageSize]="'50px'"
									[isResponsive]="true"
									[image]="brandLogoImage"
								></lib-image>
							</lib-link>
						</div>
						<div
							libFlexColumn
							libFlexFill
							class="w-box-desktop-a-brand-title ui-cursor-pointer"
							[libLineClamp]="true"
							[clampLines]="2"
							[routerLink]="dashboardUrl()"
						>
							@if (brandLogoImage.title === originalAppName() && appTextLogos(); as appTextLogos) {
							<lib-image
								[image]="appTextLogos.dark"
								[priority]="true"
								[isRound]="false"
								[alt]="originalAppName()"
								[isResponsive]="true"
								[imageSize]="'original'"
							></lib-image>
							} @else {
							{{ brandLogoImage.title }}
							}
						</div>
					</div>
					}

					<!-- Main left icons -->
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'fill'">
							<div>
								@for (sideCategory of sideMenuCategories(); track sideCategory.id; let first = $first) {
								<div
									libFlexRow
									[libFlexRowAlign]="'center'"
									[libFlexRowGap]="'16px'"
									[class.pad-top]="!first"
									class="w-box-desktop-menu-item"
								>
									<div libFlexColumn libFlexFill class="w-box-desktop-a-category">
										<div>{{ sideCategory.title }}</div>
									</div>
								</div>
								@for (item of sideCategory.items; track `${item.title+item.routerLink}`) {
								<lib-link
									[routerLink]="item.routerLink"
									[externalUrl]="item.externalUrl"
									[linkStyle]="'noUnderline'"
								>
									<div
										libFlexRow
										[libFlexRowAlign]="'center'"
										[libFlexRowGap]="'16px'"
										class="w-box-desktop-menu-item"
										[class.active]="item.isActive"
									>
										@if (item.iconType){
										<div>
											<lib-icon
												[color]="item.isActive ? 'sideMenuActive' : 'sideMenu'"
												[size]="'small'"
												[type]="item.iconType"
											></lib-icon>
										</div>
										}
										<div
											libFlexColumn
											libFlexFill
											class="w-box-desktop-a-title"
											[class.active]="item.isActive"
										>
											<div>{{ item.title }}</div>
										</div>
										@if (item.badge) {
										<div libFlexColumn>
											<div class="ui-badge">
												<div class="circle">
													<span>{{ item.badge }}</span>
												</div>
											</div>
										</div>
										}
									</div>
								</lib-link>
								} }
							</div>
						</div>
					</div>
				</div>

				@if (authUser(); as authUser) {
				<lib-tooltip-menu #userMenu>
					<div libPad>
						<div libFlexRow [libFlexRowGap]="'16px'">
							<div libFlexColumn [libFlexSize]="'70px'">
								<lib-link [linkStyle]="'noUnderline'" [routerLink]="avatarRouterLink">
									<lib-image
										[alt]="'User'"
										[maxHeight]="70"
										[maxWidth]="70"
										[imageSize]="'250px'"
										[avatarName]="userTitle()"
										[image]="authUser.avatar"
									></lib-image>
								</lib-link>
							</div>
							<div libFlexColumn [libFlexSize]="'250px'">
								<div>
									@if (userTitle(); as userTitle) {
									<h4>
										{{ userTitle }}
									</h4>
									}
								</div>
								@if (userMenuSubtitle(); as userMenuSubtitle) {
								<div libText5 libLineClamp [clampLines]="1">
									{{ userMenuSubtitle }}
								</div>
								}
							</div>
						</div>
						<lib-divider class="push-top push-bottom"> </lib-divider>
						@for (menuItem of primaryUserMenuItems(); track menuItem.title+menuItem.routerLink; let first
						=$first; let last = $last) {
						<lib-tooltip-menu-item
							[removePadding]="true"
							[removeBorder]="true"
							[typeIcon]="menuItem.iconType"
							[isFirst]="first"
							[isLast]="last"
							(itemClick)="menuItem.click()"
							[routerLink]="menuItem.routerLink"
							[title]="menuItem.title"
						></lib-tooltip-menu-item>
						}

						<lib-divider class="push-top push-bottom"></lib-divider>
						<div>
							<div libText4>Theme</div>
							<div class="push-top-sm">
								<lib-tag-list [tags]="themeTags()"></lib-tag-list>
							</div>
						</div>
						<div class="push-top">
							<div libText4>Preferred unit</div>
							<div class="push-top-sm">
								<mod-user-preferred-unit></mod-user-preferred-unit>
							</div>
						</div>
						<lib-divider class="push-top push-bottom"> </lib-divider>
						@for (menuItem of secondaryUserMenuItems(); track menuItem.title+menuItem.routerLink; let first
						=$first; let last = $last) {
						<lib-tooltip-menu-item
							[removePadding]="true"
							[removeBorder]="true"
							[isFirst]="first"
							[typeIcon]="menuItem.iconType"
							[isLast]="last"
							(itemClick)="menuItem.click()"
							[routerLink]="menuItem.routerLink"
							[title]="menuItem.title"
						></lib-tooltip-menu-item>
						}
					</div>
				</lib-tooltip-menu>
				<div class="w-box-footer">
					<div>{{ appCopyright() }}</div>
					<div class="push-top-xs">
						{{ appVersion() }}
					</div>
				</div>
				}
			</div>
		</div>
	</div>

	}
</ng-template>

<ng-template #primaryMenuMobileTemplate>
	@if (layoutType(); as layoutType) {
	<div class="w-box-wrapper">
		<div class="w-box-mobile">
			<div class="w-box-content">
				<div class="pad-left pad-right">
					@if (authUser(); as authUser) {
					<div libFlexRow class="w-title push-top" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
						<div libFlexColumn [libFlexSize]="'50px'">
							<lib-link [routerLink]="avatarRouterLink" [linkStyle]="'noUnderline'">
								<lib-image
									[alt]="'User avatar'"
									[priority]="true"
									[imageSize]="'50px'"
									[avatarName]="userTitle()"
									[image]="authUser.avatar"
								></lib-image>
							</lib-link>
						</div>
						<div libFlexColumn libFlexFill>
							@if (userTitle(); as userTitle) {
							<div class="w-mobile-title" libLineClamp [clampLines]="1">{{ userTitle }}</div>
							} @if (userSubtitle(); as userSubtitle) {
							<div class="w-mobile-subtitle" libLineClamp [clampLines]="2">{{ userSubtitle }}</div>
							}
						</div>
					</div>
					}
				</div>
				<!-- Menu content -->
				<div class="w-mobile-menu-panel-content">
					<div class="push-top pad-left pad-right">
						@for (sideCategory of sideMenuCategories(); track sideCategory.id) {

						<ng-container>
							@if (sideCategory.title && !sideCategory.hideTitle) {
							<div class="w-category-title push-top push-bottom-sm">
								{{ sideCategory.title }}
							</div>
							} @if (sideCategory.tags && sideCategory.tags.length) {
							<div class="push-top-sm">
								<lib-tag-list [tags]="sideCategory.tags"></lib-tag-list>
							</div>
							} @if (sideCategory.specialType) {
							<div class="push-top-sm">
								@if (sideCategory.specialType === 'preferredUnitSwitcher') {
								<mod-user-preferred-unit [basicTagType]="'sideMenuBasic'"></mod-user-preferred-unit>
								}
							</div>
							} @for (sideItem of sideCategory.items; track sideItem.title) {
							<div>
								<lib-link
									[routerLink]="sideItem.routerLink"
									[anchorRoute]="sideItem.anchorRoute"
									[externalUrl]="sideItem.externalUrl"
									[linkStyle]="'noUnderline'"
								>
									<div
										libFlexRow
										[libFlexRowGap]="'16px'"
										class="push-top-xs w-menu-item-link"
										[class.active]="sideItem.isActive"
									>
										<div libFlexColumn class="icon">
											<lib-icon [type]="sideItem.iconType"></lib-icon>
										</div>
										<div libFlexColumn libFlexFill>
											{{ sideItem.title }}
										</div>
										@if (sideItem.badge) {
										<div libFlexColumn>
											<div class="ui-badge">
												<div class="circle">
													<span>{{ sideItem.badge }}</span>
												</div>
											</div>
										</div>
										}
									</div>
								</lib-link>
							</div>
							}
						</ng-container>
						}
					</div>

					<!-- Footer -->
					<div class="push-top w-mobile-footer pad">
						<div>{{ appCopyright() }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	}
</ng-template>

@if (layoutType(); as layoutType) {

<!-- Mobile version -->
@if (layoutType === 'mobile') {
<div class="ui-side-menu" [id]="menuIds.primaryMenuId">
	<div class="ui-menu ui-left">
		<ng-template [ngTemplateOutlet]="primaryMenuMobileTemplate"></ng-template>
	</div>
	<div
		class="ui-overlay"
		(click)="closePrimaryMenu()"
		[attr.aria-hidden]="true"
		(keyup.enter)="closePrimaryMenu()"
	></div>
</div>

} @else {
<!-- Desktop version -->
@if (showMenuOnDesktop()) {

<ng-template [ngTemplateOutlet]="primaryMenuDesktopTemplate"></ng-template>

} } }
